// extracted by mini-css-extract-plugin
export default {"card":"c3-z"};